import { ForgotPasswordPage as SharedForgotPasswordPage } from '@remote-medium/ui';

import { authClient } from '../../lib/auth.ts';
import { SITE_ORIGIN, TURNSTILE_SITE_KEY } from '../../lib/config.ts';

export function ForgotPasswordPage() {
  return (
    <SharedForgotPasswordPage
      siteUrl={SITE_ORIGIN}
      accountType="curator"
      turnstileSiteKey={TURNSTILE_SITE_KEY}
      requestReset={(email, turnstileToken) =>
        authClient.requestPasswordReset({
          email,
          fetchOptions: { headers: { 'X-Turnstile-Token': turnstileToken } },
        })
      }
    />
  );
}
